export default "__VITE_ASSET__CWjpFWrs__"